import { call } from '@rental/contracts/client'
import type { QueryClient } from '@tanstack/react-query'
import { api, load } from '../api'

/** The customer's record (CUS-1, CUS-4), and what its correction forms read again. */
export const customerQueryKey = (customerId: string) => ['customer', customerId] as const

export const loadCustomer = (customerId: string) =>
  load(call(api.GET('/v1/staff/customers/{customerId}', { params: { path: { customerId } } })))

/** S8: the Owner's privacy panel. Never kept by the server's caches: read afresh each time. */
export const privacyQueryKey = (customerId: string) => ['customer-privacy', customerId] as const

export const loadPrivacy = (customerId: string) =>
  load(
    call(api.GET('/v1/staff/customers/{customerId}/privacy', { params: { path: { customerId } } })),
  )

/** The screens that show a customer's name or contact besides their record. */
const SHOWING_CUSTOMERS = ['customers', 'booking', 'bookings', 'today', 'timeline', 'checkout']

/**
 * S8: after a customer changed (a correction, a request, a hold), every
 * screen that shows them reads them again: the record and its panel now, the
 * others when next shown.
 */
export async function customerChanged(queryClient: QueryClient, customerId: string) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: customerQueryKey(customerId) }),
    queryClient.invalidateQueries({ queryKey: privacyQueryKey(customerId) }),
    ...SHOWING_CUSTOMERS.map((key) => queryClient.invalidateQueries({ queryKey: [key] })),
  ])
}
